export const PunchManagementRoutes = {
    "/punch-management": {
        "name": "appLayout.schedule.punch-management",
        "loginRequired": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "punchManagementContainer",
            }
        },
        "route_styles": {
            "framework": "bootstrap_v4",
            'styles': ["punch-management"]
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Punch Management"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("./punch-management.module.js");
                }
            },
        ]
    },
};